import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject, LOCALE_ID } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SubmitButton } from '../../../../shared/ui/Buttons/submit-button/submit-button';
import { ibanFormatValidator } from './create-bank-account.validators';

@Component({
  selector: 'app-create-bank-account',
  imports: [CommonModule, ReactiveFormsModule, SubmitButton],
  templateUrl: './create-bank-account.html',
  styleUrl: './create-bank-account.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateBankAccount {
  protected locale = inject(LOCALE_ID);
  private router = inject(Router);

  bankAccountForm = new FormGroup({
    bankNameArabic: new FormControl('', [Validators.required]),

    bankNameEnglish: new FormControl(''),

    accountNumber: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d+$/),
      Validators.minLength(8),
      Validators.maxLength(30),
    ]),

    iban: new FormControl('', [
      Validators.required,
      ibanFormatValidator(),
      Validators.minLength(15),
      Validators.maxLength(34),
    ]),
  });

  onCancel() {
    this.router.navigate(['/admin/bank-account']);
  }

  onSave() {
    if (this.bankAccountForm.invalid) {
      this.bankAccountForm.markAllAsTouched();
      return;
    }

    console.log(this.bankAccountForm.getRawValue());
  }
}
